import { render, staticRenderFns } from "./ChevronLeftAltIcon.vue?vue&type=template&id=16c9a3b1"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports